export const GET_TEMPLATE_SERVICE_ITEM = "GET_SERVICE_ITEM"
export const GET_TEMPLATE_BRANCH_AND_COMPANY = "GET_TEMPLATE_BRANCH_AND_COMPANY"
export const UPDATE_TEMPLATE_BRANCH_AND_COMPANY = "UPDATE_TEMPLATE_BRANCH_AND_COMPANY"
export const RESET_TEMPLATE_BRANCH_AND_COMPANY = "RESET_TEMPLATE_BRANCH_AND_COMPANY"
export const RESTORE_TEMPLATE_BRANCH_AND_COMPANY = "RESTORE_TEMPLATE_BRANCH_AND_COMPANY"
export const CHANGE_TASK_STATUS = "CHANGE_TASK_STATUS"